export default [
    { title: 'Публікації',  uri: '/публікації' },
    { title: 'Сторінки',    uri: '/сторінки' },
    { title: 'Мітки',       uri: '/мітки' },
    { title: 'Типи',        uri: '/типи' },
    { title: 'Фото',        uri: '/фото' },
]